import React from 'react';
import { Surface } from '@ukpostbox/frontend-framework';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { BatchNotesComplete } from './BatchNotesComplete';

function BatchNotes(props: RenderBatchSectionType) {
	const { currentBatchData, notesUpdating, UpdateNotes } = useForwardingBatchProvider();

	if (props.complete) {
		return <BatchNotesComplete {...props} />;
	}

	return (
		<div>
			<h5 className='mb-xs'>
				{`Step ${props.sectionIndex}: ${props.section.name}`}{' '}
				{!props.complete && !props.readOnly && props.section.isOptional ? (
					<span className='fade'>(Optional)</span>
				) : (
					''
				)}
			</h5>

			<p>If you'd like to include any notes to the mail-room, please add them in the field below.</p>

			<Surface extraClass='p-md'>
				<textarea
					rows={6}
					defaultValue={currentBatchData?.notes}
					onBlur={(e) => UpdateNotes(e.currentTarget.value)}
					disabled={notesUpdating || props.readOnly}
				/>
			</Surface>
		</div>
	);
}

export { BatchNotes };
